import React from 'react';
import { useRevealChildren } from '../../hooks/useRevealChildren';
import { Link } from 'react-router-dom';
import AboutIllustration from './AboutIllustration';
import ArrowIcon from '../shared/ArrowIcon';
import './About.css';

function About() {
  const ref = useRevealChildren();

  return (
    <section className="about-section" id="about" ref={ref}>
      <div className="container">
        <div className="about-grid">
          <AboutVisual />
          <AboutContent />
        </div>
      </div>
    </section>
  );
}

function AboutVisual() {
  return (
    <div className="about-visual reveal">
      <div className="about-visual-main">
        <AboutIllustration />
      </div>
      <div className="about-accent-card">
        <div className="about-accent-icon">
          <ClockIcon />
        </div>
        <div className="about-accent-text">
          <strong>Since 2024</strong>
          Driving sustainable impact
        </div>
      </div>
    </div>
  );
}

function AboutContent() {
  return (
    <div className="about-content reveal reveal-d2">
      <div className="section-eyebrow">About Us</div>
      <h2 className="section-title">
        Stupa Developmental<br />Foundation
      </h2>
      <p className="about-text">
        At STUPA Developmental Foundation, we aim to collaborate with a diverse
        range of stakeholders, including multilateral and bilateral agencies,
        national and subnational governments, civil society organizations,
        corporates, and others.
      </p>
      <p className="about-text">
        Our work spans critical areas such as Agriculture, Forestry, Livelihood
        Development, and Environmental Sustainability, focusing on impactful
        contributions in project planning, policy formulation, implementation,
        and strategic advisory.
      </p>
      <Link to="/about" className="btn-outline">
        Read More <ArrowIcon />
      </Link>
    </div>
  );
}

function ClockIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="24" height="24">
      <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z" />
      <path d="M12 6v6l4 2" />
    </svg>
  );
}

export default About;
